import { combineReducers, configureStore } from "@reduxjs/toolkit";
import nearbeuserReducer from "./userSlice"; // path based on your folder structure

import {
    persistReducer,
} from 'redux-persist';

import storage from 'redux-persist/lib/storage'; 

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
};


const rootReducer = combineReducers({
  nearbeUser: nearbeuserReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default store;
